export default require('../../src/front/components/Header').default;
